import React from 'react';
import { Avatar, Box, Flex, Text, VStack } from '@chakra-ui/react';
import {
	DropdownMenu,
	DropdownMenuTrigger,
} from '../../../pages/Messenger/common-components/Menu/Menu';
import { UserMenu } from './UserMenu';
import { CurrentUserType } from '../../../types';
import { ProfileLoadingPlaceholder } from './ProfileLoadingPlaceholder';

interface SideBarFooterProps {
	isLoading: boolean;
	menuExpanded: boolean;
	fullName: string;
	data?: CurrentUserType;
	onSignOut: VoidFunction;
}

export const SideBarFooter = ({
	isLoading,
	menuExpanded,
	fullName,
	data,
	onSignOut,
}: SideBarFooterProps) => {
	return (
		<Box>
			<DropdownMenu>
				{isLoading ? (
					<ProfileLoadingPlaceholder
						wrapperProps={{
							px: '10px',
						}}
					/>
				) : (
					<Box>
						{menuExpanded ? (
							<DropdownMenuTrigger asChild={true}>
								<Flex
									px="10px"
									cursor="pointer"
									align="center"
									justify="space-between"
									gap="15px"
									overflow="hidden">
									<Avatar name={fullName} boxSize="40px" />
									<Flex
										direction="column"
										minWidth="100px"
										flex={1}
										gap="2px">
										<Text color="white" fontSize="16px">
											{fullName}
										</Text>
										<Text
											color="gray.400"
											fontSize="12px"
											isTruncated={true}>
											{data?.email}
										</Text>
									</Flex>
								</Flex>
							</DropdownMenuTrigger>
						) : (
							<VStack spacing="17px" cursor="pointer">
								<DropdownMenuTrigger asChild={true}>
									<Avatar
										name={fullName}
										src={
											data?.imageUrl ? data.imageUrl : ''
										}
										boxSize="40px"
									/>
								</DropdownMenuTrigger>
							</VStack>
						)}
					</Box>
				)}
				<UserMenu onSignOut={onSignOut} />
			</DropdownMenu>
		</Box>
	);
};
